import { RefObject, useCallback, useEffect, useState } from 'react';

import { PAGE_HEADER_STICKY_HEIGHT } from '@/components/page/PageHeader/StickyPageHeader';

const useSidebarHeight = ({
  isStickyHeader,
  sidebarRef,
  pageHeaderRef,
}: {
  isStickyHeader: boolean;
  sidebarRef: RefObject<HTMLDivElement>;
  pageHeaderRef: RefObject<HTMLDivElement>;
}) => {
  const [pageHeaderHeight, setPageHeaderHeight] = useState(0);
  const [fullHeaderHeight, setFullHeaderHeight] = useState<number | null>(null);

  useEffect(() => {
    if (pageHeaderRef.current) {
      setPageHeaderHeight(pageHeaderRef.current.getBoundingClientRect().height);
    }
  }, [pageHeaderRef]);

  const calculateFullHeaderHeight = useCallback(() => {
    const sidebar = sidebarRef.current;

    if (sidebar) {
      let newHeaderHeight;
      if (isStickyHeader) {
        newHeaderHeight = (pageHeaderRef.current?.offsetTop || 0) + PAGE_HEADER_STICKY_HEIGHT;
      } else {
        const scrollTop = pageHeaderRef.current?.getBoundingClientRect().y || 0;
        newHeaderHeight = pageHeaderHeight + scrollTop;
      }

      setFullHeaderHeight(newHeaderHeight);
    }
  }, [isStickyHeader, sidebarRef, pageHeaderHeight, pageHeaderRef]);

  useEffect(() => {
    calculateFullHeaderHeight();
    if (!isStickyHeader) {
      window.addEventListener('scroll', calculateFullHeaderHeight);
    }
    window.addEventListener('resize', calculateFullHeaderHeight);

    return () => {
      window.removeEventListener('scroll', calculateFullHeaderHeight);
      window.removeEventListener('resize', calculateFullHeaderHeight);
    };
  }, [calculateFullHeaderHeight, isStickyHeader, pageHeaderHeight]);

  return { sidebarHeight: `calc(100vh - ${fullHeaderHeight}px)` };
};

export default useSidebarHeight;
